import { ActionTree } from "vuex";
import { RootState, StateSystemSettings } from "@/store/types";
import { ACTION_TYPES, MUTATION_TYPES } from "@/lib/const";
import { InputSystemSettings, SystemSettings } from "@teacherskaya/api-provider/dist/api/SystemSettingsProvider";
import providers from "@/lib/providers";

export const actions: ActionTree<StateSystemSettings, RootState> = {
  async [ACTION_TYPES.GET_DATA](context) {
    const resp = await providers.SystemSettingsProvider.get();
    context.commit(MUTATION_TYPES.STORE_DATA, resp);
    return resp;
  },
  async [ACTION_TYPES.SET_DATA](context, { data }: { data: InputSystemSettings }) {
    if (data.frontendConfig) {
      const currentDataResponse: SystemSettings = await providers.SystemSettingsProvider.get();
      const currentSettings = currentDataResponse.frontendConfig ? JSON.parse(currentDataResponse.frontendConfig) : {};
      data.frontendConfig = JSON.stringify({
        ...currentSettings,
        ...JSON.parse(data.frontendConfig),
      });
    }
    const resp = await providers.SystemSettingsProvider.update({ data });
    context.commit(MUTATION_TYPES.STORE_DATA, resp);
    return resp;
  },
};
